module.exports = __webpack_public_path__ + "mq.61a53cf5.svg";